import { css } from '@emotion/react';
import { AnalyticsDashBoardType } from 'redux/schemas/app/analytics';
import { AnalyticsContext } from 'analytics_dashboard/components/analytics-dashboard';
import QrveyWrapper from 'analytics_dashboard/components/qrvey-wrapper';


const ProgramAnalytics = () => {
  const styles = css`
    max-width: 1205px;
  `;

  return (
    <div css={styles} className='container'>
      <div className='d-flex flex-column'>
        <AnalyticsContext.Provider
          value={{
            configKeyName: 'config_mentorship_program',
            dashboardType: AnalyticsDashBoardType.MENTORSHIP_PROGRAM,
          }}
        >
          <QrveyWrapper />
        </AnalyticsContext.Provider>
      </div>
    </div>
  );
};

export default ProgramAnalytics;
